import { Component, OnInit, Input, LOCALE_ID } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CuadreService } from '../../../services/cuadre.service';
import { Helper } from '../../../helpers/helper';
import { DatePipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeDo from '@angular/common/locales/es-DO';
import localeDoExtra from '@angular/common/locales/extra/es-DO';
import { ConfiguracionesService } from '../../../services/configuraciones.service';
registerLocaleData(localeDo, 'es-DO', localeDoExtra);

@Component({
  selector: 'app-detalle-cierre-dia',
  templateUrl: './detalle-cierre-dia.component.html',
  styleUrls: ['./detalle-cierre-dia.component.css'],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-DO' }
  ]
})
export class DetalleCierreDiaComponent implements OnInit {
  @Input() apertura;
  @Input() modals;
  @Input() i;
  @Input() functions;
  datosCierre: any;
  urlImg;
  loaded = false;
  gastos = 0;
  recorrido = false;
  salidas_efectivo = 0;
  fecha_apertura: string;
  cuadre_v2: boolean;
  imprimiendoCuadre = false;

  constructor(
    public activeModal: NgbActiveModal,
    private cuadreService: CuadreService,
    private configuracionesService: ConfiguracionesService,
    private helper: Helper) {
      this.configuracionesService
      .obtenerConfiguraciones()
      .subscribe((config: any) => this.cuadre_v2 = config.cuadre_v2)
      this.urlImg = this.helper.urlImg + 'cierre_dia/';
  }

  ngOnInit() {
    this.initCierre();
    const dp = new DatePipe('es-DO');
    
    this.fecha_apertura = dp.transform(this.apertura.fecha_apertura, 'EEEE') + ', ' + dp.transform(this.apertura.fecha_apertura, 'dd') + ' de ' + dp.transform(this.apertura.fecha_apertura, 'MMMM') + ' de ' + dp.transform(this.apertura.fecha_apertura, 'yyyy');
  }

  private initCierre(): void {
    this.cuadreService.obtenerCuadre(this.apertura.ID_APERTURA_DIA).subscribe((res: any) => {
      setTimeout(() => this.loaded = true, 1);
      this.datosCierre = res;
      this.recorrido = res.recorridos > 0;
      this.gastos = res.gastos.reduce( (a, b) => a + b.monto_gasto, 0);
      this.salidas_efectivo = res.salidas_efectivo.reduce( (a, b) => a + b.capital, 0);
    });
  }

  verRecorrido(): void {
    this.activeModal.close();
    this.modals.recorridoNgbModal(this.apertura.ID_APERTURA_DIA)
    .then(() => {
      this.functions._parent.cerrarDia(this.apertura, this.i);
    });
  }

  imprimirCuadre() {
    this.helper.imprimirCuadre(this.datosCierre, this.fecha_apertura);
  }

  imprimir_cuadre(element) {
    this.imprimiendoCuadre = true;
    setTimeout(() => {
      let printContents, popupWin;
      printContents = document.getElementById(element).innerHTML;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
      <html>
      <head>
      <title>Impresión de Cuadre del Día</title>
      <style>
      hr {
        margin-top: 2px;
        margin-bottom: 2px;
        border: 1px dotted;
      }
      .table-borderless > tbody > tr > td,
      .table-borderless > tbody > tr > th,
      .table-borderless > thead > tr > td,
      .table-borderless > thead > tr > th {
        border: none;
      }
      .text-center {
        text-align: center;
      }
      </style>
      <link href="assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
      </head>
      <body onload="window.print();window.close()" style="width: 100%;">
      ${printContents}
      <br />
      <br />
      <div class="pull-left" style="text-align: center">
      _______________________________<br />
      COBRADOR
      </div>
      <div class="pull-right" style="text-align: center">
      _______________________________<br />
      SECRETARIA
      </div>
      </body>
      </html>`
    );
    popupWin.document.close();
  }, 0);
    this.imprimiendoCuadre = false;
  }

  dataV2(data: any[]) {
    if (this.cuadre_v2) {
      return data;
    }

    return [];
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/detalle-cierre-dia/detalle-cierre-dia.component.ts